import animationManager, {
  AnimationStatusCallbacks,
  makeSequence,
  SequenceStep,
} from "../../../../services/animation-manager";
import { AnimationSequences } from "@phn/utility/constants";

export function registerOpenDoubleDrawerSequence({
  onAnimationStarts,
  onAnimationEnds,
}: Required<AnimationStatusCallbacks>): void {
  const sequence: SequenceStep[] = [
    [
      {
        onStart: onAnimationStarts,
        elementSelector: "phn-nd-double-drawer",
        animation: {
          className: "opening-animation",
          cleanUpAfterAnimation: (element) => {
            element.style.translate = "0px";
          },
        },
      },
      {
        elementSelector: "phn-nd-backdrop",
        animation: {
          className: "fade-in-animation",
          cleanUpAfterAnimation: (element) => {
            element.style.opacity = "1";
            element.style.backgroundColor = "rgba(0, 0, 0, 0.6)";
          },
        },
        onEnd: onAnimationEnds,
      },
    ],
  ];

  animationManager.register(
    AnimationSequences.OPEN_DOUBLE_DRAWER,
    makeSequence(sequence),
  );
}
